module.exports = __webpack_public_path__ + "img/说明书4-05.6ea57949.png";